import { render, staticRenderFns } from "./SimilarListingsControls.vue?vue&type=template&id=bce3d78e&scoped=true&"
import script from "./SimilarListingsControls.vue?vue&type=script&lang=js&"
export * from "./SimilarListingsControls.vue?vue&type=script&lang=js&"
import style0 from "./SimilarListingsControls.vue?vue&type=style&index=0&id=bce3d78e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce3d78e",
  null
  
)

export default component.exports